import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

import {DiInlineListPageHeaderComponent} from 'app/common/di-inline-list-page-header/di-inline-list-page-header.component';
import {DiSearchBarModule} from 'app/common/di-search-bar/di-search-bar.module';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzDropdownModule} from 'ng-zorro-antd/dropdown';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DiHelpModule} from 'app/common/di-help/di-help.module';

import {MobileClickTriggerDirective} from 'app/common/mobile/mobile-click-trigger.directive';
@NgModule({
    declarations: [DiInlineListPageHeaderComponent],
    imports: [
        // Phone: dropdowns open on tap; desktop keeps hover.
        MobileClickTriggerDirective,
        CommonModule,
        TranslateModule,
        NzIconModule,
        DiSearchBarModule,
        NzDropdownModule,
        NzButtonModule,
        FlexLayoutModule,
        FontAwesomeModule,
        DiHelpModule
    ],
    exports: [DiInlineListPageHeaderComponent],
    providers: []
})
export class DiInlineListPageHeaderModule {}
